export default function servicesSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        "provider": {
            "@type": "LocalBusiness",
            "name": "Sujaramaha Enterprises",
            "url": "https://www.sujaramahaenterprises.com"
        },
        "serviceType": [
            "Computer & Printers Sales & Service",
            "CCTV Installation",
            "Solar Water Heater",
            "All types of Insurances",
            "Water Filter / RO System & Kitchen Chimneys",
            "Inverter & Battery",
            "Web Designing & Hosting",
            "Digital Marketing",
            "Home Appliances"
        ],
        "areaServed": {
            "@type": "Country",
            "name": "India"
        }
    };
}
